import React, {Component, useEffect, useState} from 'react'
import querystring from 'query-string'
import {connect, useDispatch, useSelector} from 'react-redux'

import { receiveItems, searchKeyword, clearItems } from '../../../actions/contents/template'
import TemplateListItem from './TemplateListItem';
import { parseListParams } from '../../common/EntryListHelper';
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import LoadingBox from "../../common/LoadingBox";
import LoadErrorBox from "../../../components/common/LoadErrorBox";
import * as InitStatus from '../../../constants/common/InitializationStatus';
import {addPrefix} from "../../../utils/UriUtil";


function TemplateListEmptyItems() {
  const totalCount = useSelector(state => state.template.item.totalCount)
  const { searchKeyword } = useSelector(state => state.template.condition)
  if (searchKeyword !== '') {
    if (totalCount === -1) {
      return (
        <li className="info_none">
          <div className="txt_none">
            <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
            검색 결과가 너무 많습니다. <br/>
            구체적인 단어로 다시 검색해보세요.
          </div>
        </li>
      )
    }

    return (
      <li className="info_none">
        <div className="txt_none">
          <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
          검색 결과가 없습니다.
        </div>
      </li>
    )
  }

  return (
    <li className="info_none">
      <div className="txt_none">
        <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
        아직 등록된 서식이 없습니다.
      </div>
      <a href={addPrefix(`/manage/template?returnURL=${location.pathname}`)} className="link_none">새 서식 쓰기</a>
    </li>
  )
}


function TemplateListItems({initialized, onRetryInit}) {
  const items = useSelector(state => state.template.item.items)

  if (initialized === InitStatus.INIT_DOING ) {
    return (
      <li className="info_none">
        <LoadingBox/>
      </li>
    )
  }

  if (initialized === InitStatus.INIT_FAIL) {
    return <LoadErrorBox retry={onRetryInit}/>
  }

  if (initialized === InitStatus.INIT_SUCCESS) {
    if (items.length === 0) {
      return <TemplateListEmptyItems />
    } else {
      return items.map(item =>
        <TemplateListItem key={item.id} item={item}/>
      )
    }
  }

  return null
}


export default function TemplateList({history, location, match}) {
  let listParams = parseListParams(location.search)
  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)
  const [currentPage, setCurrentPage] = useState(listParams.page)
  const [currentSearchKeyword, setCurrentSearchKeyword] = useState(listParams.searchKeyword)
  const [currentSearchType, setCurrentSearchType] = useState(listParams.searchType)

  const dispatch = useDispatch()

  function handleReceiveItems(items, totalCount) {
    dispatch(receiveItems(items, totalCount))
  }
  function handleSearch(keyword, type) {
    dispatch(searchKeyword(keyword, type))
  }

  function init() {
    fetchTemplates(currentPage, currentSearchKeyword, currentSearchType)
  }

  function fetchTemplates(page, searchKeyword, searchType) {
    setInitialized(InitStatus.INIT_DOING)
    fetch(addPrefix("/manage/templates.json?") + querystring.stringify({
      page: page,
      searchKeyword: searchKeyword,
      searchType : searchType
    }), {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleReceiveItems(data.items, data.totalCount);
        handleSearch(searchKeyword, searchType);
        setCurrentPage(page)
        setInitialized(InitStatus.INIT_SUCCESS)

      })
      .catch(e => {
        console.error(e);
        handleReceiveItems([], 0);
        setInitialized(InitStatus.INIT_FAIL)
      })
  }

  useEffect(() => {
    init()

    return () => {
      dispatch(clearItems())
    }
  }, [])

  useEffect(() => {
    let listParams = parseListParams(location.search)
    if ((currentPage != listParams.page) || (currentSearchKeyword != listParams.searchKeyword) || (currentSearchType != listParams.searchType)) {
      fetchTemplates(listParams.page, listParams.searchKeyword, listParams.searchType)
      setCurrentPage(listParams.page)
      setCurrentSearchKeyword(listParams.searchKeyword)
      setCurrentSearchType(listParams.searchType)
    }
  }, [location])


  return (
    <div className="wrap_list">
      <ul className="list_post list_post_type2">
        <TemplateListItems
          initialized={initialized}
          onRetryInit={init}
        />
      </ul>
    </div>
  )
}

